export const VossCustomerSubscriptionStatus = {
    NotSubscribed: 0,
    Active: 1
}